import type React from "react";
import { useState } from "react";
import { BiHide, BiShow } from "react-icons/bi";
import { FaChevronDown } from "react-icons/fa6";
import { FaChevronUp } from "react-icons/fa6";
import { Placeholder } from "rsuite";

import "./AnswerQuestionsItem.scss";

type Props = {
	question: string;
	answer: string;
	index: number;
};

const AnswerQuestionsItem: React.FC<Props> = ({ question, answer, index }) => {
	const [idx, setIdx] = useState<number>(-1);

	const showHideAnswer = (index: number) => {
		if (idx === index) {
			setIdx(-1);
		} else {
			setIdx(index);
		}
	};

	const shouldShow = index === idx;
	return (
		<div className="reading-activity__question-answer-item">
			<div className="reading-activity__question-answer-item-header">
				<span>
					{shouldShow ? (
						<FaChevronUp
							size={16}
							id="hide-icon"
							onClick={() => showHideAnswer(index)}
						/>
					) : (
						<FaChevronDown
							size={16}
							id="show-icon"
							onClick={() => showHideAnswer(index)}
						/>
					)}
				</span>
				<p className="reading-activity__question">{question} </p>
			</div>
			{shouldShow ? (
				<p
					className={`reading-activity__answer${shouldShow ? "-reveal" : "-hide"}`}
				>
					{answer}
				</p>
			) : (
				<Placeholder.Paragraph rows={3} />
			)}
		</div>
	);
};

export default AnswerQuestionsItem;
